import React from 'react'

import { useIntl } from 'react-intl'
import cn from 'classnames'
import { AppSvg, Button, FormattedHTMLMessage, Input, newIcons } from '@web/walter-ui-kit'
import { Details } from '../types'
import s from './s.module.css'
import { lang } from './lang'
import useCopy from '~hooks/useCopy'
import { formatDate } from '~utils/date'

interface Props {
    details?: Details
    onClose: () => void
}

function Content({ details, onClose }: Props) {
    const intl = useIntl()

    const copy = useCopy()

    const date = formatDate({ date: details?.date, formatString: 'MM/yy', tz: 'UTC' })

    return (
        <div className={s.wrap}>
            <div className={s.cardDetails}>
                <Input
                    value={details?.numbers?.match(/.{1,4}/g)?.join(' ') || '-'}
                    actionContent={<AppSvg path="new-icons" svgName={newIcons.ic24Copy} size={24} />}
                    actionType="secondary"
                    onAction={() => copy(details?.numbers || '')}
                    label={intl.formatMessage(lang.number)}
                    dataPointer="input_number"
                    readOnly
                />
                <div className={s.row}>
                    <Input
                        value={date || '-'}
                        actionContent={<AppSvg path="new-icons" svgName={newIcons.ic24Copy} size={24} />}
                        actionType="secondary"
                        onAction={() => copy(date || '')}
                        label={intl.formatMessage(lang.date)}
                        className={cn(s.dateHack, s.input)}
                        dataPointer="input_date"
                        readOnly
                    />
                    <Input
                        value={details?.code || '-'}
                        actionContent={<AppSvg path="new-icons" svgName={newIcons.ic24Copy} size={24} />}
                        actionType="secondary"
                        onAction={() => copy(details?.code || '')}
                        label={intl.formatMessage(lang.code)}
                        className={cn(s.input)}
                        dataPointer="input_code"
                        readOnly
                    />
                </div>
                <Input
                    value={details?.name || '-'}
                    actionContent={<AppSvg path="new-icons" svgName={newIcons.ic24Copy} size={24} />}
                    actionType="secondary"
                    onAction={() => copy(details?.name || '')}
                    label={intl.formatMessage(lang.name)}
                    dataPointer="input_name"
                    readOnly
                />
            </div>
            <Button dataPointer="button" size="l" mode="primary" onClick={onClose}>
                <FormattedHTMLMessage {...lang.button} />
            </Button>
        </div>
    )
}

export default Content
